import router from "@/router";
import { clearClientSession } from "@/shared/services/session_service";
// import { useLoginStore } from "@/shared/store/login_store";

export const loginService = {
  logout() {
    // const store = useLoginStore();
    clearClientSession();
    // store.clearUser();
    router.push("/");
  },
};
